import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import './AboutUs.css';

function AboutUs() {
const t = useTranslation();

return(
    <div name="AboutUs section" className="aboutus-container">
    <h1>ABOUT US</h1>
    <section name="aboutus" className="section-aboutus">
      <p>
        Vix Academy is a modern online learning platform built to empower individuals with practical, in-demand digital skills. Our mission is simple: 
        make high-quality education accessible, structured, and results-driven for people who want to grow professionally, build real-world skills, or 
        launch new career paths in today’s digital economy.
      </p>
      <p>
        We offer carefully designed course packages that combine clarity, hands-on learning, and real application. Whether you are taking your first steps
         or upgrading existing skills, Vix Academy guides you through each subject with a clear learning path, practical examples, and confidence-building progression.
      </p>

      <h2>Our Vision</h2>
      <p>
        We believe education should be practical, understandable, and empowering. In a fast-changing digital world, knowing what to learn and how to apply it matters 
        more than ever. Vix Academy exists to bridge the gap between theory and real-world execution.
      </p>
      <ul className="">
        <span>Our goal is to help those who want to keep their learning journey's, students of all ages. With our academy you can:</span>
        <li>Learn skills that are relevant and applicable</li>
        <li>Build confidence through structured learning</li>
        <li>Progress at their own pace with clarity and direction</li>
        <li>Develop knowledge they can actually use in projects, work, or business</li>
      </ul>
    </section>
    <section name="aboutus" className="section-aboutus">  
      <p>
        <h2>What We Teach</h2>
        Vix Academy offers a wide range of courses designed to cover both <b>technical skills</b> and <b>digital growth strategies</b>, 
        giving learners a complete and balanced education.
 
        <h3>Web Development & Programming</h3>
        <ul>
          <li>HTML & CSSS - Learn how to build clean, responsive, and visually appealing websites from scratch.</li>
          <li>JavaScript - Bring websites to life with interactivity, logic, and dynamic functionality.</li>
          <li>Pyhton - Master one of the most powerful and versatile programming languages for automation, problem-solving, and real applications.</li>
        </ul>
        <h3>Marketing & Online Growth</h3>
        <ul>
          <li>SEO - Step-by-step online course that simplifies complex topics, helping students learn faster, apply knowledge confidently, and achieve measurable results.</li>
        </ul>
        <h3>Trading Fundamentals</h3>
        <ul>
          <li>Trading Courses - A structured educational program designed to explain how financial markets work, how to analyze charts, manage risk,
            and develop disciplined strategies with clarity and responsibility. </li>
        </ul>
      </p>

      <p>
        <h2>Our Learning Approach</h2>
        At Vix Academy, learning is:
        <ul>
          <li>Step-by-step - Each course is structured from fundamentals to practical application. </li>
          <li>Beginner-friendly - No unnecessary complexity or assumptions.</li>
          <li>Practical-focused - Real examples, exercises, and projects.</li>
          <li>Skill-oriented - Focused on what you can do, not just what you know.</li>
        </ul>
        <span>We prioritize understanding over memorization and confidence over shortcuts.</span>
      </p>

      <p>
        <h3>Who Vix Academy is For</h3>
        Vix Academy is designed for: 
        <ul>
          <li>Beginners starting their journey in tech, marketing, or market fundamentals.</li>
          <li>Professionals looking to upgrade or diversify their skills.</li>
          <li>Entrepreneurs and freelancers building digital projects or businesses.</li>
          <li>Creators and marketers seeking structured, practical knowledge.</li>
          <li>Anyone who values clarity, structure, and real learning outcomes.</li>
        </ul>
        <span>No matter your background, our courses are designed to meet you where you are and help you move forward.</span>
      </p>
    </section>
    <section name="aboutus" className="section-aboutus">
      <h3>Our Commitment</h3>
      <p>
        We are committted to:
        <ul>
          <li>Clear, honest, and educational content.</li>
          <li>Structured learning paths with real value.</li>
          <li>Continuous improvement of our courses and materials.</li>
          <li>Empowering learners with knowledge.</li>
        </ul>
        Vix Academy is about <b>learning with purpose</b> helping you build skills that matter and confidence that lasts.
      </p>
      <h3>Start Learning With Confidence</h3>
      <p>
        At Vix Academy, education is more than content — it’s a pathway to growth. Whether you want to code, design, market, 
        or understand financial markets, we provide the tools, structure, and guidance to help you move forward with confidence.
      </p>
      <span><b>Learn. Build. Grow.</b></span>
      Welcome to <b>Vix Academy</b>
    </section>
  </div>
  
)
}

export default AboutUs;